import Vue from 'vue';

import RoNav from './RoNav';
import RoNavParent from './RoNavParent';
import RoNavItem from './RoNavItem';
import RoNavItemToggle from './RoNavItemToggle';

Vue.component('RoNav', RoNav);
Vue.component('RoNavParent', RoNavParent);
Vue.component('RoNavItem', RoNavItem);
Vue.component('RoNavItemToggle', RoNavItemToggle);

export default { RoNav, RoNavParent, RoNavItem, RoNavItemToggle };



// WEBPACK FOOTER //
// ./scripts/ro-nav/index.js